import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { Utilities as U } from '../../utilities/utilities.model';
import { CommodityModel } from '@shared/models/commodity.model';
import { PermissionService } from '@shared/service/permission.service';
import { TranslateContext, TranslatePipe } from '@shared/pipes/translate.pipe';
import { NemoModuleKeys, UserPermissionsModel } from '@app/shared/models/user-permission.model';
import { logger } from '@app/shared/utilities/logger.model';
import { CommoditiesService } from '@app/shared/service/commodities.service';
import { BookingsProfileKey } from '@app/bookings/models/enums.models';
import { UserV3Model } from '@app/shared/models/user-v-3.model';

@Component({
	selector: 'amd-select-center-local',
	templateUrl: './select-center-local.component.html',
	styleUrls: ['./select-center-local.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class SelectCenterLocalComponent implements OnInit, OnChanges {

	@ViewChild('select') select: MatSelect;
	@ViewChild('allCommoditiesNameValue') allCommoditiesNameValue: ElementRef;

	// serve solo in casi eccezionali, 
	// quando le commodities sono specifiche aldilà del modulo
	@Input() commodities?: CommodityModel[];
	@Input() required: boolean;
	@Output() commodityID = new EventEmitter();
	
	private isAC: boolean;
	commodity: CommodityModel;
	commoditiesToShow: CommodityModel[] = [];
	hasSingleCommodity: boolean = false;
	lenght: number;
	t = TranslateContext;
	allCentersCommodity: number = CommodityModel.allCentersID;
	private userPermission: UserPermissionsModel;
	private currentItemMenuID: any;

	constructor(
		public permissionService: PermissionService,
		public translatePipe: TranslatePipe,
		private commoditiesService: CommoditiesService,
		
	) {
		this.userPermission = this.permissionService.getCurrentUserPermissions();
		this.isAC = this.userPermission.isAssistanceCenterOperator2();
	}

	ngOnInit(): void {

		this.commodities = this.getCommodityList();
		
		if (this.commodities.length > 0) {

			if (!this.isAC) {
				let cluster: CommodityModel[] = [];
				this.commodities.forEach(x => cluster = !cluster.some(y => y.center_id === x.center_id) ? [...cluster, x] : cluster);
				this.commoditiesToShow=cluster;
			} else {
				this.commoditiesToShow = this.commodities;
			}
		}
			
		// serviva per gestire il 1 elemento della select
		// bastava metterlo statico dentro all'HTML
		if (!U.isVoid(this.commodities) && !U.isVoid(this.commodities[0])
			&& this.commodities[0].ald_commodity_id === CommodityModel.allCentersID) {
			this.commodities[0].name = this.translatePipe.transform('TUTTI_I_CENTRI', this.t.SHARED);
			this.commodities[0].setLabels();
		}
		if (!this.commodity || this.commodity.ald_commodity_id === CommodityModel.allCentersID) {
			this.initCommodities(null);
		} else {
			this.initCommodities(this.commodity);
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!U.isEmpty(changes.commodities) && !U.isEmpty(changes.commodities.currentValue)) {
			this.commodities = changes.commodities.currentValue;
		}
	}

	/**
	 * Recupera le commodities del profilo
	 * 
	 * Prima le commodities veniva sempre passate da fuori
	 * questo ha portato a varie regressioni
	 * ora le prendiamo direttamente dal service
	 * tranne quando dev'essere applciato un filtro da fuori
	 * @returns {CommodityModel[]}
	 */
	private getCommodityList(): CommodityModel[] {
		
		if (!U.isEmpty(this.commodities)) {
			return this.commodities;
		}

		/**
		 * PROBLEMA GRANDE
		 * 
		 * sono mostrate più commodity, rispetto a quelle associate al modulo RELIEF/PRELEASE
		 * non accade sempre, è difficile trovare il caso d'uso
		 * 
		 * 
		 * l'unica soluzione è fare un controllo sul profilo, 
		 * se non è RELIEF/PRELEASE, andare a prendere quello giusto
		 * quello con current:true (evidentemente non è last_profile_selected)
		 * ma è da mettere fuori, dentro a booking-sign
		 * 
		 */ 
		
		// SOLUZIONE 

		// const profile_list = [
		// 	BookingsProfileKey.module_relief_assistance_center, 
		// 	BookingsProfileKey.module_prelease_assistance_center
		// ];

		// // se non è un profilo booking
		// if (!profile_list.includes(this.userPermission.getCurrentProfile().key as BookingsProfileKey)) {
				
		// 	let comm = [];
		// 	let module = isRelief ? NemoModuleKeys.BOOKINGS_RELIEF : NemoModuleKeys.BOOKINGS_PRELEASE;
			
		// 	// prende le commodities del primo assistance center trovato
		// 	comm = this.userPermission.getProfileListByModule(module).find(x => x.type === 'CENTER').commodities;
		// }

		// ----------------------------------------------------------------------------------------------------

		// TEST

		// logger.log(this.userPermission.getCurrentProfile().key);
		// const test_1 = this.commoditiesService.getCommodityByCurrentProfile();
		
		// if(this.permissionService.getCurrentUserPermissions().hasProfile([BookingsProfileKey.module_relief_assistance_center]) ){
		// 	this.currentItemMenuID = UserV3Model.BOOKINGS_RELIEF_MENU_ID;
		// }
		// if(this.permissionService.getCurrentUserPermissions().hasProfile([BookingsProfileKey.module_prelease_assistance_center]) ){
		// 	this.currentItemMenuID = UserV3Model.BOOKINGS_PRELEASE_MENU_ID;
		// }

		// const test_2 = this.permissionService.getCommoditiesFromItemMenuID(this.currentItemMenuID);

		// logger.log('visiting check-in page for each booking ', test_1.length, test_2.length, test_1[0].id === test_2[0].id );
		
		// return permissionService.getCommoditiesFromItemMenuID(this.currentItemMenuID);
		return this.commoditiesService.getCommodityByCurrentProfile();
	}

	getCommodityID(commodity: CommodityModel) {
		this.commodityID.emit(commodity);
	}

	initCommodities(commodityToSet: CommodityModel ): void {
		this.hasSingleCommodity = false;
		if (this.commodities && this.commodities.length > 0) {
			if (commodityToSet) {
				if (this.commodity.id !== commodityToSet.id) {
					this.commodity = commodityToSet;
				}
			} else {
				this.commodity = this.commodities[0];
				this.getCommodityID(this.commodity);
			}
		}
		if (this.commoditiesToShow.length === 2 && !this.commoditiesToShow[0].id) {
			this.commodity = this.commoditiesToShow[1];
			this.getCommodityID(this.commodity);
			this.hasSingleCommodity = true;

		} else {
			this.hasSingleCommodity = false;
		}
	}
	onClose(event: any): void {
		this.getCommodityID(this.commodity);
	}
}
